var text_to_copy = window.location.href;
copyButton = document.querySelector('.copy-link');
if (copyButton !== null) {
    copyButton.addEventListener('click', function (event) {
        if (!navigator.clipboard) {
            var dummy = document.createElement('input');
            dummy.value = text_to_copy;
            dummy.select();
            document.execCommand('copy');
            document.body.removeChild(dummy);
        } else {
            navigator.clipboard.writeText(text_to_copy);
        }
    });
}
